import { render, staticRenderFns } from "./rs-RS.vue?vue&type=template&id=5091351e&scoped=true&"
var script = {}
import style0 from "./rs-RS.vue?vue&type=style&index=0&id=5091351e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5091351e",
  null
  
)

export default component.exports